var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVisible = function SvgVisible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.134 5C4.522-.427 12.478-.427 15.866 5c-3.388 5.427-11.344 5.427-14.732 0ZM.167 5c3.632 6.538 13.034 6.538 16.666 0C13.201-1.538 3.8-1.538.167 5Zm10 0a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0Z",
    fill: "#A7ADB3"
  })));
};

export default SvgVisible;